import './DemandedJobs.scss';
import './HireTalent.scss';
import TalentCard from "./TalentCard";
import Header from '../utils/Header';
import toList, { randomID } from '../utils/ComponentUtil';
import CustomButton from '../utils/CustomButton';
import $ from 'jquery';
import { useEffect, useState } from 'react';
import HireTalentAPI from '../Apis/HireTalentAPI';
import useWindowDimensions from '../utils/WindowDimensions';
import Carousel from '../utils/Carousel';
import TalentsAPI from '../Apis/TalentsAPI';


function HireTalent({ title = 'Recently Posted Talents', subTitle = 'Hire for your works', className = 'hire-talent-wrp',
centerMode = true, style={}, showMore = true, talents = HireTalentAPI.fetchTalents(8, 0), card = TalentCard, cardClass='talent-card-wrp',
 viewMoreCount = 4, perRow=4, talentTypes = undefined }) {

    const [rootId, setRootId] = useState(randomID());
    const { width } = useWindowDimensions();
    const isMobile = () => { return width <= 768; }
    useEffect(() => {
        $("."+ rootId+ " ." + cardClass).css('display', 'none');
        $("."+ rootId+ " ." + cardClass + ":hidden").slice(0, talents.length).css('display', 'inline-block');
    }, [rootId])
    
    const [viewMore, setViewMore] = useState(showMore);
    const viewTalents = () => {
        $("." + cardClass + ":hidden").slice(0, viewMoreCount).css('display', 'inline-block');
        setViewMore($('.'+cardClass).length !== $('.'+cardClass+':visible').length)
    };


    return (<div className={className + ' ' + rootId +  (centerMode ? ' wrapper' : ' ')} style={style}>
        <Header title={title} subTitle={subTitle} />
        <div className='talent-selected'>
            {talentTypes && <Carousel numberOfCards={5} centerMode={true} 
            cards={toList(talentTypes, undefined, (item, i) => 
            <div className='talent-type' key={i}>{item?.title}</div>)} /> }
        </div>
        <div className="talent-board-root" 
        style={{ display: 'grid', gridTemplateColumns: 'repeat(' + (isMobile() ? 1 : perRow) + ', 1fr)', gap: '16px', textAlign: 'center' }}>
            {toList([...talents], card)}
        </div>
        {viewMore ? <CustomButton name="View More" onClick={viewTalents}></CustomButton> : null}
    </div>);
}

export default HireTalent;